import React, {useEffect} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {Button, Stack} from "react-bootstrap";
import {useAlert, useAuth} from "../../context";
import {ResponsiveContent} from "../ResponsiveNavTabs";
import {regex} from "../../utils2";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";
import {ColumnizeText, PageTitle, PasswordButton, SingleText} from "../_components";

export function Login() {
    return <ResponsiveContent body={<LoginForm/>}/>
}

function LoginForm() {

    const location = useLocation()
    const navigate = useNavigate();
    const {success, error} = useAlert();
    const {login, loggedIn} = useAuth();

    useEffect(() => {
        if (loggedIn)
            navigate("/")
    }, []);

    const validationSchema = yup.object().shape({
        username: yup.string()
            .required("Email is mandatory.")
            .email("Email not valid"),
        password: yup.string()
            .required("Password is mandatory.")
            .matches(regex.password_pattern, " Password must be at least 8 characters long and include a number, uppercase, lowercase, and special character."),
    })

    const value = {
        username: "",
        password: "",
    }

    const from = location.state?.from ?location.state.from.pathname + location.state.from.search : "/";

    function handleSubmit(values, actions) {
        login(values)
            .then(data => {
                navigate(from);
                success(<p>Hi <i>{data.username}</i>.</p>, "Welcome!");
            })
            .catch(err => {
                console.warn(err);
                error(err.message);
            })
            .finally(() => actions.setSubmitting(false))
    }

    return (
        <>
            <PageTitle title="Login">Type your credentials to control your devices.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>

                        <ColumnizeText className="">
                            <SingleText name="username" label="Email" maxLength="64" autoComplete="username"/>
                            <PasswordButton name="password" label="Password" position="right" autoComplete="current-password"/>
                        </ColumnizeText>

                        <div className="d-flex flex-column mt-4">
                            <div>Didn't receive the verification email? <Link to="/account/resend-email"
                                                                              className="flex-shrink-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">Resend
                                it</Link></div>
                            <div>Forgot your password? <Link to="/account/forgot-password"
                                                             className="flex-shrink-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">Reset
                                it here</Link></div>
                            <div>New here? <Link to="/account/signup"
                                                 className="flex-shrink-0 link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">Create
                                an account</Link></div>
                        </div>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            <Button type="submit" variant="primary" disabled={isSubmitting}>Login</Button>
                        </Stack>

                    </FormikForm>
                )}
            </Formik>

        </>
    )
}
